import React from 'react';
import PropTypes from 'prop-types';
import NewProduct from '../_utils/new-product';
import productType from './types/product-type';
import preSelectionsType from './types/pre-selections-type';

function GenericProducts({
  favourites,
  preSelections,
  products,
  roundOption,
  showThumbnailImages,
  productsWithMultipleVariants,
  selectedDeliveryOptions
}) {

  return (
    <div className="row">
      {products.map(product => (
        <NewProduct
          key={product.id + product.theme_name}
          {...product}
          preSelections={preSelections}
          favourites={favourites}
          roundOption={roundOption}
          showThumbnailImages={showThumbnailImages}
          productsWithMultipleVariants={productsWithMultipleVariants}
          selectedDeliveryOptions={selectedDeliveryOptions}
        />
      ))}
    </div>
  );
}

GenericProducts.propTypes = {
  favourites: PropTypes.arrayOf(PropTypes.string),
  preSelections: preSelectionsType.isRequired,
  products: PropTypes.arrayOf(productType).isRequired,
  roundOption: PropTypes.bool.isRequired,
  showThumbnailImages: PropTypes.bool,
  selectedDeliveryOptions: PropTypes.string
};

GenericProducts.defaultProps = {
  favourites: null,
  showThumbnailImages: null
};

export default GenericProducts;
